$(document).ready(function ($) {
    $('.selectpicker-holder').selectpicker();
    $('.slick-slider').slick({
        dots: true
    });
    
    $('.js_city-change').click(function () {
        if ($(this).hasClass('active')) {
    
        } else {
            if ($(this).hasClass('js_city-change-spb')) {
                $('.contacts__city--moscow').css('display', 'none');
                $('.contacts__city--spb').css('display', 'block');
                $('.js_city-change-moscow').removeClass('active');
                $('.js_city-change-spb').addClass('active');
            } else {
                $('.contacts__city--moscow').css('display', 'block');
                $('.contacts__city--spb').css('display', 'none');
                $('.js_city-change-moscow').addClass('active');
                $('.js_city-change-spb').removeClass('active');
            }
        }
    });
    
    
    $('.js_filter-open').click(function () {
        if ($(this).hasClass('opened')) {
            $(this).removeClass('opened');
            $('.katalog-filter__form').slideToggle();
        } else {
            $(this).addClass('opened');
            $('.katalog-filter__form').slideDown();
        }
    });
    
    
    $('.js_smart-filter').click(function () {
        if ($(this).hasClass('opened')) {
            $(this).removeClass('opened');
            $('.smart-filter-form').slideToggle();
        } else {
            $(this).addClass('opened');
            $('.smart-filter-form').slideDown();
        }
    });
    
    
    $('.js_collapse-description').click(function () {
        var button = $('.detail-page__collapse-desc');
        var desc = $('.detail-page__description');
        if (desc.hasClass('detail-page__description--collapsed')) {
            desc.removeClass('detail-page__description--collapsed');
            button.removeClass('detail-page__collapse-desc--collapsed');
            button.html(function (index, text) {
                return text.replace('Показать текст полностью', 'Свернуть описание');
            });
        } else {
            desc.toggleClass('detail-page__description--collapsed');
            button.addClass('detail-page__collapse-desc--collapsed');
            button.html(function (index, text) {
                return text.replace('Свернуть описание', 'Показать текст полностью');
            });
        }
    });
    
    $('.js_collapse-requirements').click(function () {
        var button = $('.detail-page__requirements-head');
        var desc = $('.detail-page__requirements-desc');
        if (desc.hasClass('requirements__opened')) {
            desc.slideToggle('slow');
            desc.removeClass('requirements__opened');
            $(this).addClass('detail-page__requirements-head--collapsed');
        } else {
            desc.slideDown('slow');
            desc.addClass('requirements__opened');
            $(this).removeClass('detail-page__requirements-head--collapsed');
        }
    });
    
    $('.js_collapse-detail-requirements').click(function () {
        var button = $('.catalog-detail__requirements-head');
        var desc = $('.catalog-detail__requirements-desc');
        if (desc.hasClass('requirements__opened')) {
            desc.slideToggle('slow');
            desc.removeClass('requirements__opened');
            $(this).addClass('catalog-detail__requirements-head--collapsed');
        } else {
            desc.slideDown('slow');
            desc.addClass('requirements__opened');
            $(this).removeClass('catalog-detail__requirements-head--collapsed');
        }
    });
    
    /*var moveColumn = function (table, from, to) {
        var rows = $('tr', table);
        var cols;
        rows.each(function () {
            cols = $(this).children('th, td');
            cols.eq(from).detach().insertBefore(cols.eq(to));
        });
    };
    
    if ($(window).width() >= 768) {
    } else {
        moveColumn($('.customTable'), 2, 1);
    }
    
    $(window).resize(function () {
        if ($(window).width() >= 768) {
            moveColumn($('.customTable'), 2, 1);
        } else {
            moveColumn($('.customTable'), 2, 1);
        }
    });*/
    
    
    // вызов обработки формы
    $('body').on('submit', '#js_consult-form form', function (e) {
        e.preventDefault();
        form_send('#js_consult-form', 'json');
        return false;
    });
    var paginLength = $(".pagination__item").length;
    var prevBtn = $(".pagination__prev");
    var nextBtn = $(".pagination__next");
    var active = $(".pagination__item--active");
    var item = $(".pagination__item");
    var counter = 0;
    
    item.click(function() {
        if($(this).hasClass("pagination__item--active")) {
        }
        else {
            if(prevBtn.hasClass('pagination__prev--passive')) {
                prevBtn.removeClass('pagination__prev--passive');
                prevBtn.addClass('pagination__prev--active');
            }
            if(nextBtn.hasClass('pagination__next--passive')) {
                nextBtn.removeClass('pagination__next--passive');
                nextBtn.addClass('pagination__next--active');
            }
            active.removeClass('pagination__item--active');
            $(this).addClass('pagination__item--active');
            counter = 0;
            item.each(function() {
                counter++;
                if ($(this).hasClass("pagination__item--active")) {
                    if(counter == paginLength) {
                        nextBtn.addClass("pagination__next--passive");
                        nextBtn.removeClass("pagination__next--active");
                    }
                    counter--;
                    if(counter == 0) {
                        prevBtn.addClass("pagination__prev--passive");
                        prevBtn.removeClass("pagination__prev--active");
                    }
                    active = $(this);
                    return false;
                }
            });
        }
    });
    nextBtn.click(function(){
        if(counter+1 < paginLength) {
            counter++;
            active.removeClass('pagination__item--active');
            active.next().addClass('pagination__item--active');
            active = active.next();
    
            console.log(counter);
        }
        if(counter + 1 == paginLength) {
            nextBtn.addClass('pagination__next--passive');
            nextBtn.removeClass('pagination__next--active');
        }
    
        prevBtn.removeClass('pagination__prev--passive');
        prevBtn.addClass('pagination__prev--active');
    });
    prevBtn.click(function(){
        if(counter > 0){
            counter--;
            nextBtn.removeClass('pagination__next--passive');
            nextBtn.addClass('pagination__next--active');
            active.removeClass('pagination__item--active');
            active.prev().addClass('pagination__item--active');
            active = active.prev();
        }
        if(counter  == 0) {
            prevBtn.addClass('pagination__prev--passive');
            prevBtn.removeClass('pagination__prev--active');
        }
    });
    $('.js_top-menu-toggle').click(function (e) {
        if($('.top-menu__autorization').hasClass('open')) {
            $('.top-menu__autorization').removeClass('open');
            $('.person-registration').slideUp(700);
        }
        if($(window).width() < 768) {
            if($(this).hasClass('open')) {
                $(this).removeClass('open');
                $('.top-menu__nav').slideUp(700);
            } else {
                $('.top-menu__nav').slideDown(700);
                $(this).addClass('open');
            }
        }
    });
    
    $('.js_menu-close').click(function () {
        $('.js_top-menu-toggle').removeClass('open');
        $('.top-menu__nav').slideUp(700);
    });
    
    $(window).resize(function() {
       if($(window).width() >= 768) {
           $(".top-menu__nav").css("display", "block");
           $('.js_top-menu-toggle').removeClass('open');
           $(".person-registration").css("display", "none");
           $('.top-menu__autorization').removeClass('open');
       } else {
           $(".top-menu__nav").css("display", "none");
       }
    });
    
    // Меню авторизации
    
    $('.top-menu__autorization').click(function (e) {
        if($('.js_top-menu-toggle').hasClass('open')) {
            $('.js_top-menu-toggle').removeClass('open');
            $('.top-menu__nav').slideToggle(700);
        }
    
        if($(window).width() < 768) {
            if($(this).hasClass('open')) {
                $(this).removeClass('open');
                $('.person-registration').slideUp(700);
            } else {
                $('.person-registration').slideDown(700);
                $(this).addClass('open');
            }
        }
    });
});

// function simple_ajax(url) {
//     var data = {
//         "ID": "1"
//     };
//     $.ajax({
//         url: url,
//         type: "POST",
//         dataType: "HTML",
//         data: data,
//     })
//         .done(function (data) {
//             console.log('запрос прошел');
//             console.log(data);
//         })
//         .fail(function () {
//             console.log('запрос не прошел');
//         }).always(function () {
//         console.log('simple_ajax сработал');
//     });
// }


//отправка формы
// form_selector - селектор блока
// answer_type - ожидаемый тип ответа ( html, json )
// предпологается что внутри этого блока есть:
// .js_message-box - для вывода ответа
// form  - форма данные из которой отправляются
// все инпуты оформлены в .js_group-item и у них есть data-req и data-reqmess
// есть action и method
function form_send(form_selector, answer_type) {

    var my_form_holder = $(form_selector);
    var my_form = my_form_holder.find('form');
    var result_block = my_form_holder.find('.js_message-box');

    my_form.find('.js_group-item').removeClass('group-item--failed-input');
    result_block.removeClass('fail');
    var fine = 1;
    var data = my_form.serialize();

    if (!answer_type) {
        var answer_type = 'json';
    } else {
        var answer_type = answer_type;
    }

    if (!my_form.attr('method')) {
        var method = 'POST';
    } else {
        var method = my_form.attr('method');
    }

    if (!my_form.attr('action')) {
        var url = '/ajax/simple.php';
    } else {
        var url = my_form.attr('action');
    }

    result_block.html('');

    my_form.find('.js_group-item').each(function () {
        var my_item = $(this);
        var my_input = $(this).find('input:not(":file"),textarea,select');
        var req = my_item.data('req');
        var reqmess = my_item.data('reqmess');
        var textError = $(this).find('.js_text-error');

        if (my_input.is(':checkbox')) {
            if (parseInt(req) == 1 && !my_input.is(':checked')) {
                my_item.addClass('group-item--failed-input');
                textError.html(reqmess);
                textError.show();
                fine = 0;
            }
            else {
                my_item.removeClass('group-item--failed-input');
                textError.empty();
                textError.hide();
            }
        } else if (my_input.is('select')) {
            if (parseInt(req) == 1 && my_input.val() == null) {
                my_item.addClass('group-item--failed-input');
                textError.html(reqmess);
                textError.show();
                fine = 0;
            }
        } else if (my_input.val() == null && parseInt(req) == 1) {
            my_item.addClass('group-item--failed-input');
            textError.html(reqmess);
            textError.show();
            fine = 0;
        }

        else if (parseInt(req) == 1 && my_input.val() == '') {

            my_item.addClass('group-item--failed-input');
            textError.html(reqmess);
            textError.show();
            fine = 0;
        }

        my_input.on('keypress', (function () {
            my_item.removeClass('group-item--failed-input');
            textError.empty();
            textError.hide();
        }));

        my_item.on('change', (function () {
            textError.empty();
            textError.hide();
            my_item.removeClass('group-item--failed-input');
        }));


    });

    if (fine) {
        $.ajax({
            url: url,
            type: method,
            dataType: answer_type,
            data: data,
        })
            .done(function (answer) {
                result_block.html('');
                if (answer.status == 1) {
                    result_block.html(answer.message);
                    my_form[0].reset();
                    my_form.slideUp();

                } else {
                    result_block.html(answer.message);
                }

            })
            .fail(function () {
                console.log("error");
                result_block.html("Произошла ошибка при отправке, попробуйте позже");

                //функционал для обращения в конкретный инпут (по атрибуту name )
                //
                // var failed_input = 'name';
                // var failed_text_new = 'Не верно е имя ( слишком короткое )';
                // var failed_field = my_form_holder.find('[name="'+failed_input+'"]').parent();
                // дальше либо пишем в data-reqmess и выводим, либо сразу в поле ошибки

            }).always(function () {
            // udpdateCaptcha(my_form_holder);
        });
    } else {
        result_block.addClass('fail');

    }


}